module.exports = __webpack_public_path__ + "static/media/id.464311b5.svg";